module.exports = __webpack_public_path__ + "img/icon-save-to-book.5ce04a55.svg";